var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z","fill":"#F0F0F0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }